import { render } from "./index.vue?vue&type=template&id=703cd770&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=703cd770&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703cd770"],['__file',"src/views/SignUpMFA/components/step1/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "703cd770"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('703cd770', __exports__)) {
    api.reload('703cd770', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=703cd770&scoped=true", () => {
    api.rerender('703cd770', render)
  })

}


export default __exports__